module.exports = __webpack_public_path__ + "img/11-4@2x.123a0caf.jpg";